fx.ns("desktop.common.toolbar", class ToolBarSelect extends shared.stage.ToolBarAction{
    
    constructor(command, component, container)
    {
        super(command, component, container); 
    }
   
    create()
    {        
        super.create();

        this.verticalList = new fx.components.VerticalList({items: this.command.items, selected : this.component[this.command.field] });
        this.verticalList.visibleAtStart = false;
        //this.verticalList.effect = "vslide";
        var height = this.command.items.length < 5 ? 175 : 300;
        this.addChild(this.verticalList, {top : this.realHeight - 5, left : 0, width : this.realWidth, height:height});
    }

    selectionChanged()
    {
        this.verticalList.selected = this.component[this.command.field];

        let current = this.command.items.find({id : this.component[this.command.field] }); 
        this.find(".label").innerHTML = (current ? (current.toString ? current.toString() : current) : "" );

    }

    onReady()
    {

        super.onReady();

        //this.on("mousemove", this.onMouseMove, this.container);
        this.on("click", this.onClick, window);
        this.on("selected", this.onSelected, this.verticalList);
        
    }

    onClick(e)
    {
        let list = fx.dom.parent(e.target, ".VerticalList") 
        if (list && list == this.verticalList.node)
            return;

        let select = fx.dom.parent(e.target, ".ToolBarSelect") 
        if (select == this.node)
        {
            if (this.verticalList.visible)
                this.verticalList.hide();
            else
                this.verticalList.show();
        }
        else
        if (this.verticalList.visible)
                this.verticalList.hide();
    }

    onSelected(e)
    {
        this.find(".label").innerHTML = e.detail.toString ? e.detail.toString() : e.detail;
        this.action( e.detail );
    }

    render()
    {
        let current = this.command.items.find({id : this.component[this.command.field] }); 
        
        return "<div class='label'>" +  (current ? (current.toString ? current.toString() : current) : "" ) + "</div>";
    }

});
